export default "__VITE_ASSET__0V85DKa2__"